import { useState } from "react";
import {
  Button,
  Carousel,
  CarouselControl,
  CarouselIndicators,
  CarouselItem,
} from "reactstrap";

const StandardSlider = ({ items }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  //   const goToIndex = (newIndex) => {
  //     if (animating) return;
  //     setActiveIndex(newIndex);
  //   };  not needed yet
  return (
    <Carousel
      next={next}
      previous={previous}
      activeIndex={activeIndex}
      ride="carousel"
    >
      {items?.map((item, key) => (
        <CarouselItem
          onExiting={() => setAnimating(true)}
          onExited={() => setAnimating(false)}
          key={key}
        >
          {item}
        </CarouselItem>
      ))}
      <div
        className="d-flex carousel-btns full-width py-4 justify-content-center position-absolute mt-1 "
        style={{ gap: "10px",zIndex:3,bottom:0}}
      >
        <Button
          className="btn-white border-transparent"
          onClick={() => previous()}
        >
          Prev
        </Button>
        <Button className="btn-white border-transparent" onClick={() => next()}>
          Next
        </Button>
      </div>
    </Carousel>
  );
};

export default StandardSlider;
